import { render, staticRenderFns } from "./addressForm.vue?vue&type=template&id=ba865fda&scoped=true"
import script from "./addressForm.vue?vue&type=script&lang=js"
export * from "./addressForm.vue?vue&type=script&lang=js"
import style0 from "./addressForm.vue?vue&type=style&index=0&id=ba865fda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba865fda",
  null
  
)

export default component.exports